var React = require('react');

function DownloadInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.12 12H20V5.33333C20 4.6 19.4 4 18.6667 4H13.3334C12.6 4 12 4.6 12 5.33333V12H9.88002C8.69335 12 8.09335 13.44 8.93335 14.28L15.0534 20.4C15.5734 20.92 16.4134 20.92 16.9334 20.4L23.0534 14.28C23.8934 13.44 23.3067 12 22.12 12ZM6.66669 25.3333C6.66669 26.0667 7.26669 26.6667 8.00002 26.6667H24C24.7334 26.6667 25.3334 26.0667 25.3334 25.3333C25.3334 24.6 24.7334 24 24 24H8.00002C7.26669 24 6.66669 24.6 6.66669 25.3333Z","fill":"#323232"}));
}

DownloadInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = DownloadInline;

DownloadInline.default = DownloadInline;
